import React, { useState, useCallback, useEffect } from "react";
import SearchSupplierHeader from "../component/searchSupplierHeader";
import ProductInvoiceTable from "../../product_invoice/component/productInvoiceTable";
import PaginationFooter from "../../../components/footer/paginationFooter";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";
import ModalDetailProductInvoice from "../../product_invoice/component/modalDetailProductInvoice";
import ModalDeleteConfirmation from "../../../components/modal/modalDeleteConfirmation";

const UnpaidInvoice = () => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [listProductInvoiceData, setListProductInvoiceData] = useState([]);
  const [selectedProductData, setSelectedProductData] = useState({
    product_invoice_id: "",
    product_invoice_supplier_id: "",
    product_invoice_document_number: "",
    product_invoice_date: "",
    product_invoice_due_date: "",
    product_invoice_products: [],
    product_invoice_total_discount: "",
    product_invoice_total_dpp: "",
    product_invoice_total_tax: "",
    product_invoice_total_bill: "",
  });
  const [isOpenModalDetailProductInvoice, setIsOpenModalDetailProductInvoice] =
    useState(false);
  const [isOpenModalDeleteProduct, setIsOpenModalDeleteProduct] =
    useState(false);
  const [idProductToDelete, setIdProductToDelete] = useState("");
  const [supplierIdData, setSupplierIdData] = useState("");

  // =====================
  // Method
  // =====================

  const onSupplierClicked = (supplierId) => {
    setSupplierIdData(supplierId);
  };

  const onEditProduct = (productData) => {
    setSelectedProductData(productData);
    navigate(`/edit-produk-invoice`, {
      state: { productData },
    });
  };

  const onDeleteProduct = (productData) => {
    setIsOpenModalDeleteProduct(true);
    setIdProductToDelete(productData.product_invoice_id);
  };

  const onDetailProduct = (productData) => {
    setSelectedProductData(productData);
    setIsOpenModalDetailProductInvoice(true);
  };

  const onPaymentInvoiceClicked = (invoiceData) => {
    updateInvoicePaymentStatus(invoiceData.product_invoice_id);
  };

  const onCloseModalDeleteProduct = () => {
    setIdProductToDelete("");
    setIsOpenModalDeleteProduct(false);
  };

  const onCloseModal = () => {
    resetSelectedProductDataValue();
    setIsOpenModalDetailProductInvoice(false);
  };
  const onDeleteProductConfirmed = () => {
    setIsOpenModalDeleteProduct(false);
    deleteProduct();
  };

  const resetSelectedProductDataValue = () => {
    setSelectedProductData({
      product_invoice_id: "",
      product_invoice_supplier_id: "",
      product_invoice_document_number: "",
      product_invoice_date: "",
      product_invoice_due_date: "",
      product_invoice_products: [],
      product_invoice_total_discount: "",
      product_invoice_total_dpp: "",
      product_invoice_total_tax: "",
      product_invoice_total_bill: "",
    });
  };

  const onNextPageClicked = () => {
    if (page < totalPage) {
      setPage((prevPage) => {
        return prevPage + 1;
      });
    }
  };

  const onPreviousPageClicked = () => {
    if (page !== 1) {
      setPage((prevPage) => {
        return prevPage - 1;
      });
    }
  };

  // =====================
  // Request Method
  // =====================

  const getProductData = useCallback(async () => {
    try {
      setIsLoading(true);
      let url = new URL(Constant.BASE_API_URL + "/invoice-produk/belum-bayar");
      url.searchParams.append("supplierId", supplierIdData);
      url.searchParams.append("page", page);
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });
      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
      const json = await response.json();
      const data = json.data;
      const product = data.product_invoice;
      if (!product) {
        setListProductInvoiceData([]);
      }
      setListProductInvoiceData(product);
      const totalPage = data.meta.total_page;
      setTotalPage(totalPage);
    } catch (error) {
      setListProductInvoiceData([]);
    } finally {
      setIsLoading(false);
    }
  }, [page, navigate, supplierIdData]);

  const updateInvoicePaymentStatus = async (invoiceId) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        Constant.BASE_API_URL +
          "/invoice-produk/update-invoice-status/" +
          invoiceId,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Gagal Mengubah Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      getProductData();
    }
  };

  const deleteProduct = async () => {
    try {
      setIsLoading(true);
      const productId = idProductToDelete;
      const response = await fetch(
        Constant.BASE_API_URL + "/invoice-produk/" + productId,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Gagal Menghapus Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      setIdProductToDelete("");
      getProductData();
    }
  };

  useEffect(() => {
    if (supplierIdData) {
      getProductData();
    }
  }, [supplierIdData, getProductData]);

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Cek Pembayaran Invoice</h1>
      <SearchSupplierHeader onSupplierClicked={onSupplierClicked} />
      <ProductInvoiceTable
        page={page}
        product={listProductInvoiceData}
        onEditProductClicked={onEditProduct}
        onDeleteProductClicked={onDeleteProduct}
        onDetailProductClicked={onDetailProduct}
        onPaymentInvoiceClicked={onPaymentInvoiceClicked}
      />
      <ModalDetailProductInvoice
        isShowModal={isOpenModalDetailProductInvoice}
        onCloseModal={onCloseModal}
        productObject={selectedProductData.product_invoice_products}
        key={Date.now()}
      />
      <ModalDeleteConfirmation
        isShowModal={isOpenModalDeleteProduct}
        onCloseModal={onCloseModalDeleteProduct}
        onDeleteConfirmed={onDeleteProductConfirmed}
        idToDelete={idProductToDelete}
      />
      <PaginationFooter
        isPreviousActive={page > 1}
        isNextActive={page < totalPage}
        onNextClick={onNextPageClicked}
        onPrevClick={onPreviousPageClicked}
      />
    </div>
  );
};

export default UnpaidInvoice;
